import { useState } from 'react'
import PropTypes from 'prop-types'
import useMediaQuery from '@mui/material/useMediaQuery'

import { SVGWrapper } from '../../../components'
import { ArtCardCash, ArtCardPiggyBank, ArtCardStocks, ArtCardTarget } from '../../../assets/icons'
import {
  CardBack,
  CardDetail,
  CardFront,
  CardGrid,
  CardInner,
  CardLabel,
  CardOuter,
  UPSELL_LARGE_ICON_VIEWPORT,
} from './styles'

const FEATURES = [
  {
    label: 'Savings rate guidance',
    icon: ArtCardPiggyBank,
    detail: 'Know exactly how much to save across your accounts',
  },
  {
    label: 'Investment advice',
    icon: ArtCardStocks,
    detail: 'Know exactly what to invest in and at what percent',
  },
  {
    label: 'Retirement projections',
    icon: ArtCardTarget,
    detail: 'Retirement income projections for a weak, average, and strong market',
  },
  {
    label: 'Drawdown help',
    icon: ArtCardCash,
    // Soft hyphen lets "recommendations" wrap cleanly on narrow cards.
    detail: 'Drawdown recom\u00ADmendations after retirement',
  },
]

const FlipCard = ({ label, icon, detail, iconSize }) => {
  const [flipped, setFlipped] = useState(false)

  return (
    <CardOuter type='button' aria-pressed={flipped} onClick={() => setFlipped(f => !f)}>
      <CardInner $flipped={flipped}>
        <CardFront>
          <SVGWrapper svg={icon} size={iconSize} margin='0px' />
          <CardLabel>{label}</CardLabel>
        </CardFront>
        <CardBack>
          <CardDetail>{detail}</CardDetail>
        </CardBack>
      </CardInner>
    </CardOuter>
  )
}

FlipCard.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  detail: PropTypes.string.isRequired,
  iconSize: PropTypes.string.isRequired,
}

const FeatureCards = () => {
  const usesLargeIcon = useMediaQuery(UPSELL_LARGE_ICON_VIEWPORT)

  return (
    <CardGrid>
      {FEATURES.map(card => (
        <FlipCard key={card.label} {...card} iconSize={usesLargeIcon ? 'custom70' : 'custom50'} />
      ))}
    </CardGrid>
  )
}

export default FeatureCards
